import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ChatbotInterruptedVariant } from '@/models/chatbot';
import Text from '@/storybook/components/Text/Text';
import styles from './StoppedResponseDivider.module.css';
import { STOPPED_RESPONSE_DIVIDER_TEST_IDS } from './testIds';

export interface StoppedResponseDividerProps {
  variant?: ChatbotInterruptedVariant;
}

const StoppedResponseDivider: FC<StoppedResponseDividerProps> = ({ variant = 'live' }) => {
  const { t } = useTranslation();
  const message =
    variant === 'history'
      ? t('components.aiChatDrawer.stop.historyDividerMessage')
      : t('components.aiChatDrawer.stop.dividerMessage');
  const [announcedMessage, setAnnouncedMessage] = useState('');

  useEffect(() => {
    setAnnouncedMessage(message);
  }, [message]);

  return (
    <div
      className={styles.container}
      role="status"
      aria-live="polite"
      data-testid={STOPPED_RESPONSE_DIVIDER_TEST_IDS.container}
    >
      <Text as="span" className={styles.message}>
        {announcedMessage}
      </Text>
    </div>
  );
};

export default StoppedResponseDivider;
